<script>
    export let stamp
    import moment from 'moment'

    const get_expiration = stamp => {
        stamp = moment(stamp)

        return `${stamp.format('MMM D, YYYY HH:mm')} (${stamp.fromNow()})`
    }
</script>

<span>{get_expiration(stamp)}</span>
